<template>
  <div class="big new-doctor">
    <div class="container" style="padding: 10px 20px 20px 20px">
      <div class="search-box">
        <!-- 结算账期 -->
        <div class="item">
          <span style="margin-left: 10px">结算账期</span>

          <el-date-picker
            v-model="newDoctorForm.month"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            placeholder="请选择"
            size="small"
            :picker-options="pickerOptions"
            clearable
          >
          </el-date-picker>
        </div>

        <!-- 账号 -->
        <div class="item">
          <span style="margin-left: 10px">账号</span>
          <el-input
            v-model="newDoctorForm.phone"
            clearable
            size="small"
            style="width: 180px"
            placeholder="请输入"
          ></el-input>
        </div>

        <!-- 姓名 -->
        <div class="item">
          <span style="margin-left: 10px">姓名</span>
          <el-input
            v-model="newDoctorForm.recommender_name"
            clearable
            size="small"
            style="width: 180px"
            placeholder="请输入"
          ></el-input>
        </div>

        <!-- 工号 -->
        <div class="item">
          <span style="margin-left: 10px">工号</span>
          <el-input
            v-model="newDoctorForm.recommender_code"
            clearable
            size="small"
            style="width: 180px"
            placeholder="请输入"
          ></el-input>

          <el-button
            type="primary"
            size="small"
            style="margin-left: 20px"
            @click="seachEnterFun"
            >查询</el-button
          >

          <el-button type="primary" size="small" @click="resetBtn"
            >重置</el-button
          >

          <el-button
            type="primary"
            size="small"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1936') : false
            "
            @click="exportBtn"
            >导出</el-button
          >
        </div>
      </div>

      <div style="color: #f56c6c; text-align: left; margin-bottom: 10px">
        注：由于订单数据按支付时间计算，建议每月7号之后导出结算数据
      </div>

      <div class="statistics-card">
        <!-- 开单新医生总数 -->
        <el-card class="box-card">
          <div class="desc">
            <div class="value">{{ newDoctorInfo.new_doctor_num }}</div>
            <div class="title">开单新医生总数</div>
          </div>
        </el-card>

        <!-- 奖励总计 -->
        <el-card class="box-card">
          <div class="desc">
            <div class="value">{{ newDoctorInfo.total_reward }}元</div>
            <div class="title">奖励总计</div>
          </div>
        </el-card>
      </div>

      <div style="border: solid 1px #c9cbd6">
        <el-table
          v-loading="tableLoading"
          :data="newDoctorData"
          tooltip-effect="dark"
          ref="multipleTable"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            v-for="item in tableHeader"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'recommender_info'">
                <div>{{ scope.row.recommender_name }}</div>
                <div>{{ scope.row.recommender_code }}</div>
                <div>{{ scope.row.phone }}</div>
              </div>

              <div v-else>
                {{
                  JSON.stringify(scope.row[item.prop]) === "null"
                    ? ""
                    : scope.row[item.prop]
                }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <pagination
        v-show="totalNum > 0"
        :total="totalNum"
        :page.sync="pagination.page"
        :limit.sync="pagination.pageNumber"
        @pagination="getList"
      />
    </div>
  </div>
</template>
  
  <script>
import _ from "lodash";
import dayjs from "dayjs";
import staff from "@/api/staff.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDate,
      },
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      newDoctorInfo: {},
      newDoctorForm: {
        month: "",
        phone: "",
        recommender_name: "",
        recommender_code: "",
      },
      tableHeader: [
        {
          label: "员工信息",
          prop: "recommender_info",
          width: "120",
          align: "center",
          fixed: "left",
        },
        {
          label: "大区",
          prop: "area_name",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "开单新医生人数",
          prop: "new_doctor",
          width: "160",
          align: "center",
          fixed: false,
        },
        {
          label: "开单新医生信息",
          prop: "doctor_info",
          width: "auto",
          align: "center",
          fixed: false,
        },

        {
          label: "奖励金额",
          prop: "reward_money",
          width: "260",
          align: "center",
          fixed: false,
        },
      ],
      newDoctorData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.initDate();
    this.getList();
  },
  methods: {
    initDate() {
      const date = new Date();
      date.setMonth(date.getMonth() - 1); // 将当前日期减去一个月
      // 设置日期为当月的第一天
      date.setDate(1);
      this.newDoctorForm.month = dayjs(date).format("YYYY-MM");
    },
    disabledDate(date) {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth(); // 获取当前月份，0表示1月，11表示12月

      // 禁用当前月份之后的日期（不禁用当前月份）
      return (
        date.getFullYear() > currentYear ||
        (date.getFullYear() === currentYear && date.getMonth() > currentMonth)
      );
    },
    getList() {
      let params = Object.assign({}, this.pagination, this.newDoctorForm);
      this.tableLoading = true;
      staff.newDoctorReward(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.newDoctorData = data.list;
          this.newDoctorInfo = data.count_data;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun() {
      this.pagination.page = 1;
      this.getList();
    },
    resetBtn() {
      this.newDoctorForm = {
        month: "",
        phone: "",
        recommender_name: "",
        recommender_code: "",
      };
      this.getList();
    },
    // 导出
    exportBtn() {
      let params = Object.assign({}, this.pagination, this.newDoctorForm);
      const loading = this.$loading();
      staff
        .newDoctorRewardExport(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            let host = `${document.location.protocol}//${window.location.host}${data.url}`;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
  },
};
</script>
  
  <style lang="scss">
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.new-doctor {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
  .prompt {
    font-size: 12px;
    text-align: left;
    color: red;
    padding-left: 10px;
    margin-bottom: 10px;
  }
  .statistics-card {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .box-card {
      width: 19%;
      height: 120px;
      margin-right: 18px;
      .el-card__body {
        .desc {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .value {
            font-size: 20px;
            font-weight: bold;
            height: 50%;
          }
          .title {
            padding: 10px 0;
            height: 50%;
          }
        }
      }
    }
  }
}
.new-doctor-mess {
  width: 400px !important;
  .el-message-box__message {
    p {
      word-wrap: break-word;
    }
  }
}
.cus-passwordDia {
  .passwordDia-box {
    display: flex;
    align-items: center;
    .label {
      width: 100px;
    }
    .btn {
      margin-left: 10px;
    }
  }
}
</style>
  
  <style lang="scss">
.newDoctorData-sendCardVisible {
  .content-box {
    padding: 20px 10px 0;
    .el-form-item__content {
      display: flex;
      align-items: center;
      .el-input-number {
        width: 100%;
      }
    }
  }
}
</style>
  